<template>
  <div>
    <!-- :hideAdd="panes.length >= 8" -->
    <a-tabs v-model="activeKey" class="tabsPane" type="editable-card" @edit="onEdit" :hideAdd="true">
      <a-tab-pane v-for="(pane,i) in panes" :key="i" :tab="paneTitle(i)" :closable="pane.closable">
        <pane 
          :noAlert="noAlert"
          :ref="paneRef" 
          :list="pane.data" 
          :listField="listField" 
          :tabKey="activeKey" 
          :head="head" 
          :columnsField="columnsField"
          :resDate="pane.date"
          :costField="costField"
          @changeDate="changeDate"
          :varietyType="varietyType"
        />
      </a-tab-pane>
      <a-button type="primary" slot="tabBarExtraContent" @click="() => onEdit(undefined,'add')" v-if="panes.length < 8">
        +
      </a-button>
    </a-tabs>
  </div>
</template>
<script>
import {stockingInfoColumns} from '../Columns'
import Pane from './Pane'
import { mapMutations,mapState } from 'vuex';
import moment from 'moment'
export default {
  props:['list','listField','head','columnsField','dateField','noAlert','costField','varietyType'],
  components: {Pane},
  data() {
    return {
      form: this.$form.createForm(this),
      len: 2,
      stockingInfoColumns,
      activeKey: 0,
      panes: [],
      numbers: ['一','二','三','四','五','六','七','八','九',],
      newTabIndex: 2,
      visible:false,
      date:'',
      fishInfoDetail:[[]],
      hideAdd:false,

    };
  },
  watch: {
    varietyVisible(val){
      if(!val && this.varietyType === 'varietyVisible'){
        let d = this.$refs[`pane${this.activeKey}`][0].date || null
        let dStr = d ? moment(d).format('YYYY-MM-DD') : null
        if(this.listField === this.paneType) {
          let list = this.varietySelect.map(el => {
            el.time = this.activeKey + 1
            el[this.head.dateField] = dStr
            return el
          })
          this.panes[this.activeKey].data = list
        }
      }
    },
    variety2Visible(val){
      if(!val && this.varietyType === 'variety2Visible'){
        let d = this.$refs[`pane${this.activeKey}`][0].date || null
        let dStr = d ? moment(d).format('YYYY-MM-DD') : null
        if(this.listField === this.paneType) {
          let list = this.varietySelect.map(el => {
            el.time = this.activeKey + 1
            el[this.head.dateField] = dStr
            return el
          })
          this.panes[this.activeKey].data = list
        }
      }
    },
    activeKey(val){
      this.$emit('active',val)
    },
  },
  mounted(){
    this.setInfo()
  },
  computed: {
    ...mapState('empirical',['varietyVisible','variety2Visible','varietySelect','paneType']),
    paneRef(){
      return `pane${this.activeKey}`
    },
  },
  methods: {
    ...mapMutations('empirical',['setState']),
    changeDate(val){
      if(this.list[this.activeKey]) this.list[this.activeKey][this.dateField] = val || null
    },
    paneTitle(i){
      return `第${this.numbers[i]}次`
    },
    setInfo(){
      this.panes = this.list.map((el,index) => {
        return { title: `第${this.numbers[index]}次`, data: el.details, key: index ,closable: true,date: el[this.dateField]}
      })
    },
    onEdit(targetKey, action) {
      this[action](targetKey);
    },
    add(){
      let len = this.panes.length
      let key = len ? +(this.panes[len - 1].key) + 1 : 0
      this.panes.push({ title: `第${this.numbers[key]}次`, data: [], key ,closable: true})
      this.list.push({
        details: [],
        [this.dateField]: '',
      })
      if(len === 0) this.activeKey = 0
    },
    remove(targetKey){
      this.$confirm({
        title: '提示信息',
        content: '信息删除后无法恢复，确认删除本次信息吗？',
        cancelText:'取消',
        okText:'确定',
        onOk:()=>{
          let i = this.panes.findIndex((el,ind) => ind === targetKey)
          this.activeKey = this.panes.length > targetKey + 1 ? targetKey : (targetKey > 0 ? (targetKey - 1) : 0)
          this.panes.splice(i,1)
          this.list.splice(i,1)
        }
      })
    },
    // 选择放养品种并渲染表格
    getSelect(val){
      if(!this.fishInfoDetail[this.activeKey-1].length){
        val.forEach(item => {
          this.fishInfoDetail[this.activeKey-1].push({
            date:this.date,
            time:this.activeKey,
            varietyId:item.varietyId,
            varietyName:item.varietyName,
            varietyLabelName:item.varietyLabelName,
            varietyLabelCode:item.varietyLabelCode,
            stockingSpecification:'',
            stockingNum:'',
            stockingWeight:'',
          })
        })
        this.fishInfoDetail[this.activeKey-1].push({
          varietyName:'总计',
          stockingSpecification:'',
          stockingNum:0,
          stockingWeight:0,
        })
      }
      else{
        val.forEach(item => {
          this.fishInfoDetail[this.activeKey-1].splice(this.fishInfoDetail[this.activeKey-1].length - 1, 0, {
            date:this.date,
            time:this.activeKey,
            varietyId:item.varietyId,
            varietyName:item.varietyName,
            varietyLabelName:item.varietyLabelName,
            varietyLabelCode:item.varietyLabelCode,
            stockingSpecification:'',
            stockingNum:'',
            stockingWeight:'',
          })
        })
      }
    },
    // 删除某条品种信息
    deleteFeedInfo(index){
      if(index == 0) this.fishInfoDetail[this.activeKey-1].splice(index,2);
      this.fishInfoDetail[this.activeKey-1].splice(index,1);
    },
  },
};
</script>

<style lang="scss">
.tabsLable {
  .ant-form-item-label {
    line-height: 40px !important;
  }
}
.tabsPane{
  .ant-tabs-bar{
    height: 40px;
  }
  .ant-tabs-nav-container{
    // display: inline-block;
    float: left;
  }
  .ant-tabs-extra-content{
    float: none !important;
    display: inline-block;
  }
}
</style>
